import {
    addDoc,
    collection,
    deleteDoc,
    doc,
    onSnapshot,
    orderBy,
    query,
    updateDoc,
    where
} from 'firebase/firestore';
import { db } from '../firebase/firebase';
import { CustomOrder } from '../models/CustomOrder';
import userService from './user.service';

class CustomOrdersService {
    constructor() {
        this.collection = 'customOrders';
        this.unsubscribe = null;
    }

    async createCustomOrder(orderData) {
        const collectionRef = collection(db, this.collection);
        const storeId = await userService.getUserStoreId();
        const order = new CustomOrder({
            ...orderData,
            id: null,
            storeId: storeId,
            createdAt: new Date().toISOString(),
            status: 'created'
        });
        const docRef = await addDoc(collectionRef, order.toJson());
        order.id = docRef.id;
        return order;
    }

    async listenToOrders(callback) {
        const storeId = await userService.getUserStoreId();
        const collectionRef = collection(db, this.collection);
        const q = query(
            collectionRef,
            where('store_id', '==', storeId),
            orderBy('pickupDate', 'asc')
        );
        this.unsubscribe = onSnapshot(q, (snapshot) => {
            const orders = snapshot.docs
                .map((docSnap) => CustomOrder.fromFirebase(docSnap))
                .sort((a, b) => {
                    if (a.pickupDate === b.pickupDate) {
                        return (a.pickupTime || '').localeCompare(b.pickupTime || '');
                    }
                    return a.pickupDate.localeCompare(b.pickupDate);
                });
            callback(orders);
        });
    }

    stopListening() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }
    }

    async updateOrderStatus(orderId, status) {
        const docRef = doc(db, this.collection, orderId);
        await updateDoc(docRef, {
            status,
            delivered: status === 'delivered'
        });
    }

    async updateOrder(orderId, updates) {
        const docRef = doc(db, this.collection, orderId);
        await updateDoc(docRef, updates);
    }

    async deleteOrder(orderId) {
        const docRef = doc(db, this.collection, orderId);
        await deleteDoc(docRef);
    }
}

const customOrdersService = new CustomOrdersService();
export default customOrdersService;
